import i18n from 'i18next';
import { toast } from '@hooks/useToast';

const DEDUPE_MS = 5000;
const lastShown: Record<string, number> = {};

export const getErrorStatus = (error: unknown) => {
  if (!error || typeof error !== 'object' || !('status' in error)) return undefined;
  return typeof error.status === 'number' ? error.status : undefined;
};

const getMessageKey = (status?: number) => {
  if (status === 403) return 'messages.failure.request.forbidden';
  if (status && status >= 500) return 'messages.failure.request.server';
  return undefined;
};

const getErrorUrl = (error: unknown) => {
  if (!error || typeof error !== 'object' || !('url' in error)) return undefined;
  return typeof error.url === 'string' ? error.url : undefined;
};

export const isSilentError = (error: unknown) =>
  getErrorStatus(error) === 403 && Boolean(getErrorUrl(error)?.startsWith('dropdowns/'));

export const isNotifiedGlobally = (error: unknown) => Boolean(getMessageKey(getErrorStatus(error)));

export const notifyQueryError = (error: unknown) => {
  const key = getMessageKey(getErrorStatus(error)) || 'messages.failure.request.default';
  const now = Date.now();
  if (now - (lastShown[key] || 0) < DEDUPE_MS) return;
  // eslint-disable-next-line immutable/no-mutation
  lastShown[key] = now;
  toast({ title: i18n.t(key, { ns: 'app' }), variant: 'destructive' });
};
